// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1xYaJ","tab":"Tabs_tab__lzc5F","tabActive":"Tabs_tabActive__20iZM"};